import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmsComponent } from './dms.component';
import { CompanyComponent } from './components/company/company.component';
import { NumberedStepsModule } from '../../shared/components/numbered-steps/numbered-steps.module';
import { DmsRoutingModule } from './dms-routing.module';
import { BreadcrumbModule } from 'src/app/shared/modules/breadcrumb/breadcrumb.module';

@NgModule({
  declarations: [DmsComponent, CompanyComponent],
  imports: [
    DmsRoutingModule,
    CommonModule,
    NumberedStepsModule,
    BreadcrumbModule,
  ],
})
export class DmsModule {}
